import { configureApiClient } from "@/api";
import router, { resetRouter, secureRouter } from "@/router";
import store, { OrgModule, UserModule } from "@/store";
import BootstrapVue from "bootstrap-vue";
import PortalVue from "portal-vue";
import Vue from "vue";
import i18n from "./i18n";
import { userDataLoader } from "./utils/auth-service";
import { AuthManager } from "./utils/auth-service/auth-manager";
import { UserRedirector } from "./utils/auth-service/user-redirector";
import { createVueInstance } from "./vue-instance";

(window as any).__GRAPHAPI_VERSION__ =
  process.env.VUE_APP_CODEBUILD_SOURCE_VERSION || process.env.VUE_APP_COMMIT_ID;

const authManager = new AuthManager(userDataLoader, router, resetRouter);

configureApiClient({
  UserModule,
  OrgModule,
  authManager,
});

// Configure router
secureRouter(userDataLoader, new UserRedirector(OrgModule));

if (window.Cypress) {
  window.__store__ = store;
}

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(PortalVue);

authManager.initialize();

Vue.prototype.$authManager = authManager;

createVueInstance(i18n, router, store).$mount("#app");
